<div class="login-form">
  <form [formGroup]="loginForm" (ngSubmit)="login()">
    <h2 class="text-center">Log in</h2>
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Username" required="required" formControlName="email">
    </div>
    <div class="form-group">
      <input type="password" class="form-control" placeholder="Password" required="required" formControlName="password">
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-primary btn-block">Log in</button>
    </div>
  </form>
</div>
